import React from 'react'
import classNames from 'classnames'

import styles from './index.module.css'

const GroupPanel = ({ children, isSidebarOpen }) => {
  const toggleFilterContainerStyle = classNames(styles.filterGroupContainer, {
    [styles.showOnDesktop]: isSidebarOpen,
    [styles.showOnMobile]: !isSidebarOpen
  })

  return (
    <div
      className={toggleFilterContainerStyle}
      aria-label={isSidebarOpen ? 'Collapse filter' : 'Expand filter'}
    >
      {children}
    </div>
  )
}

export default GroupPanel
